jQuery( window ).on('load', function() {

  jQuery('#tuote-ostoskoriin').click(function(e){
    if ( jQuery('.tuote__lajitunnus--none').hasClass('selected') || jQuery('.tuote__urheilukuva--none').hasClass('selected') ) {
      if ( jQuery('.tuote__lajitunnus--none').hasClass('selected') ) {
        if ( jQuery('.tuote__nauha--none').hasClass('selected') ) {
          if ( confirm('Oletko varma että haluat lisätä tuotteen ostoskoriin ilman lajitunnusta ja nauhaa?') == false ) {
            e.preventDefault();
          }
        } else {
          if ( confirm('Oletko varma että haluat lisätä tuotteen ostoskoriin ilman lajitunnusta?') == false ) {
            e.preventDefault();
          }
        }
      }
      if ( jQuery('.tuote__urheilukuva--none').hasClass('selected') ) {
        if ( jQuery('.tuote__nauha--none').hasClass('selected') ) {
          if ( confirm('Oletko varma että haluat lisätä tuotteen ostoskoriin ilman urheilukuvaa ja nauhaa?') == false ) {
            e.preventDefault();
          }
        } else {
          if ( confirm('Oletko varma että haluat lisätä tuotteen ostoskoriin ilman lajitunnusta?') == false ) {
            e.preventDefault();
          }
        }
      }
    } else {
      if ( jQuery('.tuote__nauha--none').hasClass('selected') ) {
        if ( confirm('Oletko varma että haluat lisätä tuotteen ostoskoriin ilman nauhaa?') == false ) {
          e.preventDefault();
        }
      }
    }
  });

  jQuery('#koko').change(function() {
    if ( jQuery('#koko option:selected').val() == "" ) {
      jQuery('#tuote-ostoskoriin').addClass('disabled');
      jQuery('#tuotekoodi').html("- odottaa valintaa -");
      jQuery('.tuote__hinta').html('alk. <span id="tuote__hinta">' + jQuery('#koko').find(":selected").data('price') + ' €</span>');
    } else {
      jQuery('#tuote-ostoskoriin').removeClass('disabled');
    }
    var valittu = jQuery(this).find(":selected");
    if ( jQuery(this).find("option:selected").val() != "" ) {
      if ( valittu.data('sale') === 1 ) {
        jQuery('.tuote__hinta').html('<span id="tuote__hinta"></span>');
        jQuery('#tuote__hinta').html( '<del>' + valittu.data('regular-price') + ' €</del> ' + valittu.data('price') + ' €' );
      } else {
        jQuery('.tuote__hinta').html('<span id="tuote__hinta"></span>');
        jQuery('#tuote__hinta').html( valittu.data('price') + ' €' );
      }
    }
  });

  jQuery('#vari').change(function() {
    if ( jQuery('#vari option:selected').val() == "" ) {
      jQuery('#tuote-ostoskoriin').addClass('disabled');
      jQuery('#tuotekoodi').html("- odottaa valintaa -");
    } else {
      jQuery('#tuote-ostoskoriin').removeClass('disabled');
    }
    jQuery('.tuote__rivi-oikea img').each(function() {
      jQuery(this).removeClass('visible');
    });
    if ( jQuery('#vari').find(":selected").val() != "") {
      jQuery('.' + jQuery('#vari').find(":selected").val()).addClass('visible');
    }
  });

  jQuery('#koko').change();
  jQuery('#vari').change();
});

function setTuoteKuva(ele, url, width, height) {
  jQuery("#tuote__kuva").attr("src", url);
  jQuery("#tuote__kuva").attr("width", width);
  jQuery("#tuote__kuva").attr("height", height);
  jQuery(".tuote__kuvagallerian-kuva").each(function(){
    jQuery(this).removeClass("active");
  });
  jQuery(ele).addClass("active");
}

function toggleDesc(ele) {
  jQuery('.tuote__kuvausteksti').addClass('show');
  jQuery(ele).hide();
}


function changeCount(dir) {
  let val = parseInt( jQuery('#tuote__maara-count').attr('data-value') );
  newVal = 1;
  if ( dir == '+' ) {
    newVal = val + 1;
  }

  if ( dir == '-' && val > 1 ) {
    newVal = val - 1;
  }
  jQuery('#tuote__maara-count').val(newVal);
  setCount(newVal);
}

jQuery('#tuote__maara-count').change(function() {
  setCount( parseInt( jQuery(this).val() ) );
});

jQuery('#tuote__maara-count').on('keyup', function() {
  setCount( parseInt( jQuery(this).val() ) );
});

function setCount(newVal) {
  if ( !Number.isInteger(newVal) || newVal < 1 ) {
    newVal = 1;
    jQuery('#tuote__maara-count').val(1);
  }
  jQuery('#tuote__maara-count').attr('data-value', newVal);
  jQuery('#tuote-ostoskoriin').attr('data-quantity', newVal);
  updateAddToCartUrl();
  jQuery('.kaiverrus__valinta').change();
  updateProductRowCount();
}



// OSTOSKORI-URL:N PÄIVITYS
function updateAddToCartUrl() {
  let url = jQuery('#tuote-ostoskoriin').data('url');
  let id = jQuery('#tuote-ostoskoriin').data('id');
  let quantity = parseInt( jQuery('#tuote-ostoskoriin').attr('data-quantity') );

  // POHJA-URL
  let addToCartUrl = url + '?add-to-cart=' + id;
  if ( quantity > 1 ) {
    addToCartUrl = addToCartUrl + '&quantity=' + quantity;
  }
  
  // LAJITUNNUS
  if(jQuery('.tuote__lajitunnus--btn.selected').length) {
    let lajitunnus = jQuery('.tuote__lajitunnus--btn').data('lajitunnusnro');
    addToCartUrl = addToCartUrl + '&lajitunnus=' + lajitunnus;
  }

  // OMA KUVA
  if((jQuery('.tuote__lajitunnus--lataus-btn.selected').length || jQuery('.tuote__urheilukuva--lataus-btn.selected').length) && parseInt( jQuery('#tuote-ostoskoriin').data('omakuva') )) {
    let omakuva = parseInt( jQuery('#tuote-ostoskoriin').data('omakuva') );
    addToCartUrl = addToCartUrl + '&omakuva=' + omakuva;
  }

  // URHEILUKUVA
  if(jQuery('.tuote__urheilukuva--btn.selected').length) {
    let urheilukuva = jQuery('.tuote__urheilukuva--btn').data('urheilukuvanro');
    addToCartUrl = addToCartUrl + '&urheilukuva=' + urheilukuva;
  }

  // NAUHA
  if(jQuery('.tuote__nauha--btn.selected').length) {
    let lajitunnus = jQuery('.tuote__nauha--btn').data('nauhanro');
    addToCartUrl = addToCartUrl + '&nauha=' + lajitunnus;
  }

  // KAIVERRUS
  if ( jQuery('#tuote-ostoskoriin').attr('data-kaiverrus') != '' ) {
    let kaiverrus = jQuery('#tuote-ostoskoriin').attr('data-kaiverrus');
    addToCartUrl = addToCartUrl + '&kaiverrus=' + kaiverrus;
  }

  jQuery('#tuote-ostoskoriin').attr('href', addToCartUrl);
}



// LAJITUNNUS
function selectLajitunnus(ele) {
  if(jQuery(ele).hasClass('tuote__lajitunnus--btn')) {
    jQuery('.tuote__popup--lajitunnus').addClass('open');
  }

  if(jQuery(ele).hasClass('tuote__lajitunnus--lataus-btn')) {
    jQuery('.tuote__popup--oma-kuva').addClass('open');
  }

  jQuery('.tuote__lajitunnus').each(function(){
    jQuery(this).removeClass("selected");
  });

  jQuery(ele).addClass("selected");
  updateAddToCartUrl();
}

function clearLajitunnus(ele) {
  jQuery('.tuote__lajitunnus--btn').css('background-image', '');
  jQuery('.tuote__lajitunnus--lataus-btn').css('background-image', '');
  jQuery('.tuote__lajitunnus--btn').data('lajitunnusnro', '');
  jQuery('#tuote-ostoskoriin').data('omakuva', '');
  jQuery('.tuote__lajitunnus--btn .tuote__lajitunnus-teksti').removeClass('hidden');
  jQuery('.tuote__lajitunnus--lataus-btn .tuote__lajitunnus-teksti').removeClass('hidden');
  jQuery('.omakuva__rivi--valittu').hide();
  jQuery('#omankuvanhinta').html(jQuery('#omankuvanhinta').data('perushinta') + ' €');
  jQuery('#omankuvanhinta').data('hinta', jQuery('#omankuvanhinta').data('perushinta'));
  jQuery('#valitullekuvalle').css('display','none');

  jQuery('.tuote__lajitunnus').each(function(){
    jQuery(this).removeClass("selected");
  });
  
  jQuery(ele).addClass("selected");
  updateAddToCartUrl();
}



// NAUHA
function selectNauha(ele) {
  if(jQuery(ele).hasClass('tuote__nauha--btn')) {
    jQuery('.tuote__popup--nauha').addClass('open');
  }
  jQuery('.tuote__nauha').each(function(){
    jQuery(this).removeClass("selected");
  });
  jQuery(ele).addClass("selected");
  updateAddToCartUrl();
}

function clearNauha(ele) {
  jQuery('.tuote__nauha--btn').css('background-image', '');
  jQuery('.tuote__nauha--btn').data('nauhanro', '');
  jQuery('.tuote__nauha--btn .tuote__lajitunnus-teksti').removeClass('hidden');

  jQuery('.tuote__nauha').each(function(){
    jQuery(this).removeClass("selected");
  });
  
  jQuery(ele).addClass("selected");
  updateAddToCartUrl();
}



// URHEILUKUVA
function selectUrheilukuva(ele) {
  if(jQuery(ele).hasClass('tuote__urheilukuva--btn')) {
    jQuery('.tuote__popup--urheilukuva').addClass('open');
  }
  if(jQuery(ele).hasClass('tuote__urheilukuva--lataus-btn')) {
    jQuery('.tuote__popup--oma-kuva').addClass('open');
  }
  jQuery('.tuote__urheilukuva').each(function(){
    jQuery(this).removeClass("selected");
  });
  jQuery(ele).addClass("selected");
  updateAddToCartUrl();
}

function clearUrheilukuva(ele) {
  jQuery('.tuote__urheilukuva--btn').css('background-image', '');
  jQuery('.tuote__urheilukuva--btn').data('urheilukuvanro', '');
  jQuery('.tuote__urheilukuva--btn .tuote__lajitunnus-teksti').removeClass('hidden');
  jQuery('.tuote__lajitunnus--lataus-btn').css('background-image', '');
  jQuery('#tuote-ostoskoriin').data('omakuva', '');
  jQuery('.tuote__lajitunnus--lataus-btn .tuote__lajitunnus-teksti').removeClass('hidden');
  jQuery('.omakuva__rivi--valittu').hide();
  jQuery('#omankuvanhinta').html(jQuery('#omankuvanhinta').data('perushinta') + ' €');
  jQuery('#omankuvanhinta').data('hinta', jQuery('#omankuvanhinta').data('perushinta'));
  jQuery('#valitullekuvalle').css('display','none');

  jQuery('.tuote__urheilukuva').each(function(){
    jQuery(this).removeClass("selected");
  });
  
  jQuery(ele).addClass("selected");
  updateAddToCartUrl();
}





// VARIAATIO
jQuery('.tuote__variaatio').change(function() {
  updateVariation();
});

function closeTuotePopup() {
  jQuery('.tuote__popup').each(function() {
    jQuery(this).removeClass('open');
  });
  saveAllRows();
}

jQuery(document).ready(function() {
  jQuery('#tuotekoodi').html(jQuery('.tuote__variaatio').find(":selected").data('tuotenro'));
  jQuery('#koko').change();

  if ( jQuery('#variaatiot').length == 0 ) {
    updateVariation();
  }

  // POPUPIN SULKU
  jQuery('.tuote-popup__close').click(function() {
    closeTuotePopup();
  });

  // LAJITUNNUKSEN VALINTA
  jQuery('.tuote-popup__img--lajitunnus').click(function() {
    var img = "url('" + jQuery(this).attr('src') + "')";
    jQuery('.tuote__lajitunnus--btn').css('background-image', img);
    jQuery('.tuote__lajitunnus--btn').data('lajitunnusnro', jQuery(this).data('lajitunnus'));
    jQuery('.tuote__lajitunnus--btn .tuote__lajitunnus-teksti').addClass('hidden');
    jQuery('.tuote__popup').each(function() {
      jQuery(this).removeClass('open');
    });
    updateAddToCartUrl();
  });

  // URHEILUKUVAN VALINTA
  jQuery('.tuote-popup__img--urheilukuva').click(function() {
    var img = "url('" + jQuery(this).attr('src') + "')";
    jQuery('.tuote__urheilukuva--btn').css('background-image', img);
    jQuery('.tuote__urheilukuva--btn').data('urheilukuvanro', jQuery(this).data('urheilukuva'));
    jQuery('.tuote__urheilukuva--btn .tuote__lajitunnus-teksti').addClass('hidden');
    jQuery('.tuote__popup').each(function() {
      jQuery(this).removeClass('open');
    });
    updateAddToCartUrl();
  }); 

  // NAUHAN VALINTA
  jQuery('.tuote-popup__img--nauha').click(function() {
    var img = "url('" + jQuery(this).attr('src') + "')";
    jQuery('.tuote__nauha--btn').css("background-image", img);
    jQuery('.tuote__nauha--btn').data('nauhanro', jQuery(this).data('nauha'));
    jQuery('.tuote__nauha--btn .tuote__lajitunnus-teksti').addClass('hidden');
    jQuery('.tuote__popup').each(function() {
      jQuery(this).removeClass('open');
    });
    updateAddToCartUrl();
  });

  // OMAN KUVAN HINTA
  jQuery('.omakuva__valinta').change(function() {
    jQuery('#omankuvanhinta').html(jQuery('#omankuvanhinta').data('hinta') + ' €');
    if (this.value == 'lataa') {
      jQuery('.omakuva__rivi--lataa').removeClass('hidden');
      jQuery('.omakuva__rivi--valitse').addClass('hidden');
    }
    if (this.value == 'valitse') {
      jQuery('.omakuva__rivi--valitse').removeClass('hidden');
      jQuery('.omakuva__rivi--lataa').addClass('hidden');
    }
  });
});





// ASETA OMAKUVA
function setOmakuva(okid, src, width, height, price, ele) {
  if (jQuery('.tuote__lajitunnus--lataus-btn').length) {
    jQuery('.tuote__lajitunnus--lataus-btn').css('background-image', 'url(\'' + src + '\')');
    jQuery('.tuote__lajitunnus--lataus-btn .tuote__lajitunnus-teksti').addClass('hidden');
  }
  if (jQuery('.tuote__urheilukuva--lataus-btn').length) {
    jQuery('.tuote__urheilukuva--lataus-btn').css('background-image', 'url(\'' + src + '\')');
    jQuery('.tuote__urheilukuva--lataus-btn .tuote__lajitunnus-teksti').addClass('hidden');
  }
  if (price == '0') {
    jQuery('#omakuvamaksettu').html(' <b>on maksettu</b>');
  }
  if (price != '0') {
    jQuery('#omakuvamaksettu').html('a <b>ei ole maksettu</b>');
  }
  jQuery('.omakuva__kuva').each(function(){
    jQuery(this).removeClass('current');
  });
  jQuery(ele).addClass('current');
  jQuery('#omankuvanhinta').html(price + ' €');
  jQuery('#omankuvanhinta').data('hinta', price);
  jQuery('#valitullekuvalle').css('display','inline');
  jQuery('.omakuva__valittu-kuva').attr('src', src);
  jQuery('.omakuva__valittu-kuva').attr('width', width);
  jQuery('.omakuva__valittu-kuva').attr('height', height);
  jQuery('.omakuva__rivi--valittu').show();
  jQuery('#tuote-ostoskoriin').data('omakuva', okid);
  updateAddToCartUrl();
}





// VARIAATIOIDEN PÄIVITYS
function updateVariation() {
  if ( jQuery('#variaatiot').length > 0 ) {
    let atts = jQuery('#variaatiot').data('attrs').split('|');
    let variations = {};

    atts.forEach(function(att) {
      variations[att] = jQuery('#' + att).val();
    });

    let filter = jQuery.map(variations, function(val, key) {
      return '[data-' + key + '="' + val + '"]';
    });

    filter = filter.toString().replace(',','');

    let id = jQuery('#variaatiot li').filter(filter).data('id');
    let sku = jQuery('#variaatiot li').filter(filter).data('sku');

    jQuery('#tuote-ostoskoriin').data('id', id);
    jQuery('#tuotekoodi').html(sku);
    updateAddToCartUrl();
  }
}

jQuery(document).ready(function(){
  jQuery('.pocal-taulukko').each(function(){
    jQuery(this).find('td').each(function(){
      var tdi = jQuery(this).index();
      var th = jQuery(this).parents('.pocal-taulukko').find('thead tr th').eq(tdi).text()
      if ( th != '' && th != '-' ) {
        jQuery(this).attr('data-label', th + ': ');
      }
    });
  });
})